

























import { TextType, TextOptions, isNumber } from 'expangine-runtime';
import { SimpleFieldSettings, friendlyList } from '../../../common';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<TextType, any>().extend({
  name: 'TextEditor',
  computed: {
    description(): string {
      const { min, max, requireUpper, requireLower, forceUpper, forceLower } = this.type.options;
      const things: string[] = [];

      if (isNumber(min) && isNumber(max)) {
        things.push('between ' + min + ' and ' + max + ' characters');
      } else if (isNumber(min)) {
        things.push('at least ' + min + ' characters');
      } else if (isNumber(max)) {
        things.push('no more than ' + max + ' characters');
      }
      if (requireUpper) {
        things.push('must be uppercase');
      }
      if (requireLower) {
        things.push('must be lowercase');
      }
      if (forceUpper) {
        things.push('forced to uppercase');
      }
      if (forceLower) {
        things.push('forced to lowercase');
      }

      return friendlyList(things);
    },
  },
});
